module.exports = "/images/ny-life2-17.jpg";